// extracted by mini-css-extract-plugin
export default {"wrap":"qr-z","fullWidth":"rr-z","items":"sr-z","featureCss":"tr-z","disabled":"ur-z","imgCss":"vr-z"};